import React from 'react';
import { matchingTable } from './helper/matchingTable';
import { CourseHeader } from './CourseHeader';
import { CustomDivider } from './CustomDivider';
import { CourseInfo } from './CourseInfo';
import { CourseContentWrapper } from './CourseContentWrapper';
import { IliasContentList } from './IliasContentList';
import { GroupContent } from './GroupContent';
import { Typography } from '@mui/material';

export const CourseData = ({ courseInfo }) => {
	const hasCourseContents = Array.isArray(courseInfo.courseContents) && courseInfo.courseContents.length > 0;
	const hasFallbackLink = (courseInfo.trainingTypeShort ?? '') in matchingTable;

	return (
		<div style={{ container: 'course-info / inline-size' }}>
			<CourseHeader courseData={courseInfo} color='#083163' />
			<CustomDivider />
			<CourseInfo courseData={courseInfo} color='#083163' />
			<CourseContentWrapper icon='infoBulb' title='Infoportal'
								  titleAddOn='(Anleitung BigBlueButton, Stornofristen, Abrechnungen etc.)'
								  link='https://lernwelt.drv-bund.de/goto.php?target=crs_253212&client_id=weiterbildung' />
			{hasFallbackLink && (
				<CourseContentWrapper icon='content' title='Lerninhalte' link={courseInfo.iliasCourseLink} />
			)}
			{!hasFallbackLink && <>
					<CourseContentWrapper icon='content' title='Lerninhalte'>
						{hasCourseContents ?
						<IliasContentList items={courseInfo.courseContents} />
						: <Typography>Bisher wurden keine Lerninhalte eingestellt.</Typography>}
					</CourseContentWrapper>
			</>}
			<CourseContentWrapper icon='wrapUp' title='Terminbezogene Inhalte'>
				<GroupContent />
			</CourseContentWrapper>
		</div>
	);
};
